/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MessageRequest = {
  data: {
    content: string
    company?: number | string
    professional?: number | string
    initiator?: MessageRequest.initiator
    receiverRead?: boolean
    receiverNotified?: boolean
  }
}
export namespace MessageRequest {
  export enum initiator {
    PROFESSIONAL = 'professional',
    COMPANY = 'company',
  }
}
